module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_CIMB.0dc4815a.png";